// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const GoalFeather = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M63.278 37.83c-4.733 19.798-24.14 22.1-24.96 22.188a2 2 0 0 0-.258 3.935l5.616 1.34c-7.439 3.288-17.449 5.176-24.839 3.651C24.653 57.532 35.38 42.2 54.623 29.202a2 2 0 1 0-2.239-3.314C33.266 38.8 22.28 53.76 16.078 65.402c-3.875-11.6.393-23.092 3.318-28.959l1.19 4.207a2 2 0 0 0 3.683.408c13.498-24.916 41.677-28.223 54.455-28.37-5.148 3.94-12.199 11.568-15.446 25.141m24.205-27.163a2 2 0 0 0-1.756-1.729c-.442-.05-42.388-4.452-62.553 26.166l-1.23-4.35a2.001 2.001 0 0 0-3.57-.592c-.578.837-13.833 20.436-4.68 40.02-3.879 8.377-5.052 14.19-5.159 14.754a2.001 2.001 0 0 0 3.93.748c.024-.128 1.08-5.33 4.594-13.057 2.326.576 4.858.851 7.492.851 9.133 0 19.403-3.139 25.826-7.208a2 2 0 0 0-.607-3.635l-3.16-.754c7.2-2.799 17.214-9.13 20.56-23.12 4.807-20.099 18.483-25.745 19.056-25.973a2 2 0 0 0 1.257-2.12"
			fillRule="evenodd"
		/>
	</svg>
);
export default GoalFeather;
